import { Injectable, Inject  } from "@angular/core";
import { Observable, throwError, of } from "rxjs";
import 'rxjs/add/operator/map';
import 'rxjs/operator';
import 'rxjs/add/operator/catch';
import { HttpClient } from "@angular/common/http";
import { IFormConferenceInvitation } from "../Models/Forms/IFormConferenceInvitation";
import { BaseService } from './BaseService';

@Injectable()
export class FormConferenceInvitationService  extends  BaseService {

  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string)
  {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getFormConferenceInvitation(id: number) {
    return this._http.get(this._baseUrl + "api/FormConferenceInvitation/" + id)
      .map((response: IFormConferenceInvitation) => response as IFormConferenceInvitation)
      .catch(this.errorHandler);
  }

  insertUpdateFormConferenceInvitation(formConferenceInvitationDetails: IFormConferenceInvitation) {
    return this._http.post(this._baseUrl + 'api/FormConferenceInvitation', formConferenceInvitationDetails)
      .map((response: IFormConferenceInvitation) => response as IFormConferenceInvitation)
      .catch(this.errorHandler);
  }

  validateForm(id: number) {
    return this._http.get(this._baseUrl + "api/FormConferenceInvitation/ValidateForm" + id)
      .map((response: string[]) => response as string[])
      .catch(this.errorHandler)
  }

  deleteConferenceInvitation(id) {
    return this._http.delete(this._baseUrl + "api/FormConferenceInvitation" + id)
      .map((response: IFormConferenceInvitation) => response as IFormConferenceInvitation)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }

}


